import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=4e00894e&scoped=true&"
import script from "./BaseFilter.vue?vue&type=script&lang=js&"
export * from "./BaseFilter.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=4e00894e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e00894e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e00894e')) {
      api.createRecord('4e00894e', component.options)
    } else {
      api.reload('4e00894e', component.options)
    }
    module.hot.accept("./BaseFilter.vue?vue&type=template&id=4e00894e&scoped=true&", function () {
      api.rerender('4e00894e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseFilter.vue"
export default component.exports